import type { Serializable } from '@playcastdotio/CoreTypes';
import type { PlaycastMessage, PlaycastMessageSource, PlaycastMessageStateReplication } from '../types';
import { formatMessage } from './_util/formatMessage';

const target = 'state';

export const replication = (
  channel: string,
  state: Serializable,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageStateReplication<string>> => {
  const hostAuth = 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageStateReplication<string> = {
    target,
    action: 'replication',
    isReply: false,
    message: {
      channel,
      state,
    },
  };
  return formatMessage(hostAuth, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageStateReplication<string>>;
};
